var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"}));
}

Filter.defaultProps = {"className":"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-uqopch","focusable":"false","aria-hidden":"true","viewBox":"0 0 24 24","data-testid":"FilterListIcon"};

module.exports = Filter;

Filter.default = Filter;
